// Product showcase
class ProductShowcase extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.js-product-showcase');

    const observeOptions = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.35, 1]
    };

    this.observer = new IntersectionObserver(this.initEffect.bind(this), observeOptions);
    this.observer.observe(this.container)
  }

  initEffect(entries, observer) {
    const _this = this;

    entries.forEach(entry => {
      console.log(entry.intersectionRatio)
      if (entry.intersectionRatio > 0.3) {
        _this.container.querySelector('.fade-appear').classList.add('finished');
        _this.container.querySelector('.transform-appear').classList.add('finished');

        observer.unobserve(this.container);
        this.observer.disconnect();
      }
    });
  }
}
customElements.define('product-showcase', ProductShowcase);
